import { render } from "./AddNewTariff.vue?vue&type=template&id=5a9d3321&scoped=true"
import script from "./AddNewTariff.vue?vue&type=script&lang=js"
export * from "./AddNewTariff.vue?vue&type=script&lang=js"

import "./AddNewTariff.vue?vue&type=style&index=0&id=5a9d3321&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9d3321"]])

export default __exports__